import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AttendanceRecord } from "../../services/attendanceService"

interface AttendanceState {
  attendances: AttendanceRecord[]
  loading: boolean
  error: string | null
}

const initialState: AttendanceState = {
  attendances: [],
  loading: false,
  error: null
}

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    setAttendances: (state, action: PayloadAction<AttendanceRecord[]>) => {
      state.attendances = action.payload
    },
    addAttendance: (state, action: PayloadAction<AttendanceRecord>) => {
      state.attendances.push(action.payload)
    },
    updateAttendance: (state, action: PayloadAction<AttendanceRecord>) => {
      const index = state.attendances.findIndex(a => a.id === action.payload.id)
      if (index !== -1) {
        state.attendances[index] = action.payload
      }
    },
    deleteAttendance: (state, action: PayloadAction<number>) => {
      state.attendances = state.attendances.filter(a => a.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  }
})

export const {
  setAttendances,
  addAttendance,
  updateAttendance,
  deleteAttendance,
  setLoading,
  setError
} = attendanceSlice.actions

export default attendanceSlice.reducer 